// extracted by mini-css-extract-plugin
export var retroIconsStrip = "retroIconsStrip-module--retro-icons-strip--933f0";